import { apiClient } from './request'

type JsonObject = Record<string, unknown>

/** Agent 调用与 Token 统计 */
export interface AgentMetrics {
  totalCalls: number
  successCalls: number
  failedCalls: number
  totalTokens: number
  inputTokens: number
  outputTokens: number
}

/** 沙箱运行统计 */
export interface SandboxMetrics {
  sandboxRuns: number
  /** 已结束运行的总时长（毫秒） */
  sandboxDurationMs: number
}

export interface MonitorTimeRange {
  /** RFC3339 */
  fromTimestamp: string
  /** RFC3339 */
  toTimestamp: string
}

const num = (value: unknown) => {
  const parsed = typeof value === 'number' ? value : Number(value ?? 0)
  return Number.isFinite(parsed) ? parsed : 0
}

async function data(path: string, range: MonitorTimeRange): Promise<JsonObject> {
  const envelope = (
    await apiClient.post<JsonObject>('/v2/' + path, {
      from_timestamp: range.fromTimestamp,
      to_timestamp: range.toTimestamp
    })
  ).data
  return (envelope.data ?? {}) as JsonObject
}

export const monitorApi = {
  getMetrics: async (range: MonitorTimeRange): Promise<AgentMetrics> => {
    const raw = await data('GetMetrics', range)
    const calls = (raw.agent_calls ?? {}) as JsonObject
    const tokens = (raw.token_usage ?? {}) as JsonObject
    return {
      totalCalls: num(calls.total_calls),
      successCalls: num(calls.success_calls),
      failedCalls: num(calls.failed_calls),
      totalTokens: num(tokens.total_tokens),
      inputTokens: num(tokens.input_tokens),
      outputTokens: num(tokens.output_tokens)
    }
  },

  getSandboxMetrics: async (range: MonitorTimeRange): Promise<SandboxMetrics> => {
    const raw = await data('GetSandboxMetrics', range)
    const sandbox = (raw.sandbox_runs ?? {}) as JsonObject
    return {
      sandboxRuns: num(sandbox.runs),
      sandboxDurationMs: num(sandbox.total_duration_ms)
    }
  }
}
